// // src/cognito.js
// // Dual Cognito pool configuration — Admin and User
// import {
//   CognitoUserPool,
//   CognitoUser,
//   AuthenticationDetails,
// } from 'amazon-cognito-identity-js';

// // ── Pool configs ─────────────────────────────────────────────────────────────
// const ADMIN_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_DZUDc4tDX',      // original admin pool
//   ClientId:   '75ql5hhopq20p1u0fau4rjgb3v',
// });

// const USER_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_KDDaUsYp1',       // new user pool
//   ClientId:   '7rjgl5bi96pac7j6b994q25lb',
// });

// // Export whichever pool is active (used by App.js for getCurrentSession)
// export let userPool = USER_POOL;

// /**
//  * Sign in against the chosen role's Cognito pool.
//  * role: 'admin' | 'user'
//  */
// export function signIn(username, password, role = 'user') {
//   const pool = role === 'admin' ? ADMIN_POOL : USER_POOL;
//   // Keep userPool in sync so getCurrentSession / signOut work correctly
//   userPool = pool;

//   return new Promise((resolve, reject) => {
//     const authDetails = new AuthenticationDetails({
//       Username: username,
//       Password: password,
//     });
//     const cognitoUser = new CognitoUser({ Username: username, Pool: pool });
//     cognitoUser.authenticateUser(authDetails, {
//       onSuccess: (session) => resolve({ session, cognitoUser, role }),
//       onFailure: (err) => reject(err),
//       newPasswordRequired: (userAttributes) => {
//         reject({ code: 'NewPasswordRequired', userAttributes, cognitoUser });
//       },
//     });
//   });
// }

// /**
//  * Sign out — tries both pools so the active session is always cleared.
//  */
// export function signOut() {
//   [ADMIN_POOL, USER_POOL].forEach(pool => {
//     const user = pool.getCurrentUser();
//     if (user) user.signOut();
//   });
// }

// /**
//  * Get the current session from whichever pool last signed in.
//  * Tries USER_POOL first, falls back to ADMIN_POOL.
//  */
// export function getCurrentSession() {
//   return new Promise((resolve, reject) => {
//     const tryPool = (pool) =>
//       new Promise((res, rej) => {
//         const user = pool.getCurrentUser();
//         if (!user) return rej(new Error('No current user'));
//         user.getSession((err, session) => {
//           if (err || !session?.isValid()) return rej(err || new Error('Invalid session'));
//           userPool = pool; // keep in sync
//           res(session);
//         });
//       });

//     tryPool(USER_POOL)
//       .then(resolve)
//       .catch(() => tryPool(ADMIN_POOL).then(resolve).catch(reject));
//   });
// }


// // src/cognito.js
// // Dual Cognito pool configuration — Admin and User
// import {
//   CognitoUserPool,
//   CognitoUser,
//   CognitoUserAttribute,
//   AuthenticationDetails,
// } from 'amazon-cognito-identity-js';

// // ── Pool configs ─────────────────────────────────────────────────────────────
// const ADMIN_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_DZUDc4tDX',      // original admin pool
//   ClientId:   '75ql5hhopq20p1u0fau4rjgb3v',
// });

// const USER_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_KDDaUsYp1',       // new user pool
//   ClientId:   '7rjgl5bi96pac7j6b994q25lb',
// });

// // Export whichever pool is active (used by App.js for getCurrentSession)
// export let userPool = USER_POOL;

// /**
//  * Sign in against the chosen role's Cognito pool.
//  * role: 'admin' | 'user'
//  */
// export function signIn(username, password, role = 'user') {
//   const pool = role === 'admin' ? ADMIN_POOL : USER_POOL;
//   // Keep userPool in sync so getCurrentSession / signOut work correctly
//   userPool = pool;

//   return new Promise((resolve, reject) => {
//     const authDetails = new AuthenticationDetails({
//       Username: username,
//       Password: password,
//     });
//     const cognitoUser = new CognitoUser({ Username: username, Pool: pool });
//     cognitoUser.authenticateUser(authDetails, {
//       onSuccess: (session) => resolve({ session, cognitoUser, role }),
//       onFailure: (err) => reject(err),
//       newPasswordRequired: (userAttributes) => {
//         reject({ code: 'NewPasswordRequired', userAttributes, cognitoUser });
//       },
//     });
//   });
// }

// /**
//  * Sign out — tries both pools so the active session is always cleared.
//  */
// export function signOut() {
//   [ADMIN_POOL, USER_POOL].forEach(pool => {
//     const user = pool.getCurrentUser();
//     if (user) user.signOut();
//   });
// }

// /**
//  * Get the current session from whichever pool last signed in.
//  * Tries USER_POOL first, falls back to ADMIN_POOL.
//  */
// export function getCurrentSession() {
//   return new Promise((resolve, reject) => {
//     const tryPool = (pool) =>
//       new Promise((res, rej) => {
//         const user = pool.getCurrentUser();
//         if (!user) return rej(new Error('No current user'));
//         user.getSession((err, session) => {
//           if (err || !session?.isValid()) return rej(err || new Error('Invalid session'));
//           userPool = pool; // keep in sync
//           res(session);
//         });
//       });

//     tryPool(USER_POOL)
//       .then(resolve)
//       .catch(() => tryPool(ADMIN_POOL).then(resolve).catch(reject));
//   });
// }

// // ══════════════════════════════════════════════════════════════════════════════
// // ROLE MANAGEMENT — Sign up managers directly from frontend
// // ══════════════════════════════════════════════════════════════════════════════

// /**
//  * Create a new manager account via Cognito signUp (frontend SDK).
//  * Uses ADMIN_POOL so managers log in with the "admin" role toggle.
//  *
//  * @param {string} email
//  * @param {string} password
//  * @param {string} fullName
//  * @param {string} role          — e.g. 'service_manager'
//  * @param {string[]} permissions — e.g. ['onboard_customers','recharge']
//  * @returns {Promise<{ user, userConfirmed, userSub }>}
//  */
// export function signUpManager(email, password, fullName, role = 'service_manager', permissions = []) {
//   return new Promise((resolve, reject) => {
//     const attributeList = [
//       new CognitoUserAttribute({ Name: 'email', Value: email.toLowerCase() }),
//       new CognitoUserAttribute({ Name: 'name',  Value: fullName || email.split('@')[0] }),
//     ];

//     // Add custom attributes if configured in the pool
//     // (You must first add these in Cognito Console → User Pool → Custom attributes)
//     try {
//       attributeList.push(
//         new CognitoUserAttribute({ Name: 'custom:role', Value: role }),
//         new CognitoUserAttribute({ Name: 'custom:permissions', Value: JSON.stringify(permissions) }),
//       );
//     } catch (e) {
//       console.warn('[signUpManager] Custom attributes not supported, storing in localStorage', e);
//     }

//     ADMIN_POOL.signUp(
//       email.toLowerCase(),  // username = email
//       password,
//       attributeList,
//       null,                 // validation data
//       (err, result) => {
//         if (err) {
//           console.error('[signUpManager] Error:', err);
//           return reject(err);
//         }
//         console.log('[signUpManager] Created:', result.user.getUsername(), 'confirmed:', result.userConfirmed);

//         // Also store permissions locally for quick lookup
//         // (backup in case custom attributes aren't configured)
//         try {
//           const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//           stored.push({
//             email: email.toLowerCase(),
//             fullName: fullName || '',
//             role,
//             permissions,
//             status: result.userConfirmed ? 'CONFIRMED' : 'UNCONFIRMED',
//             userSub: result.userSub,
//             createdAt: new Date().toISOString(),
//           });
//           localStorage.setItem('hoags_managers', JSON.stringify(stored));
//         } catch (e) { /* ignore */ }

//         resolve({
//           user: result.user,
//           userConfirmed: result.userConfirmed,
//           userSub: result.userSub,
//         });
//       }
//     );
//   });
// }

// /**
//  * Confirm a manager's email with verification code.
//  * Call this after signUpManager if the pool requires email verification.
//  *
//  * @param {string} email
//  * @param {string} code — 6-digit code from email
//  */
// export function confirmManager(email, code) {
//   return new Promise((resolve, reject) => {
//     const cognitoUser = new CognitoUser({
//       Username: email.toLowerCase(),
//       Pool: ADMIN_POOL,
//     });
//     cognitoUser.confirmRegistration(code, true, (err, result) => {
//       if (err) return reject(err);

//       // Update local status
//       try {
//         const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//         const idx = stored.findIndex(m => m.email === email.toLowerCase());
//         if (idx >= 0) {
//           stored[idx].status = 'CONFIRMED';
//           localStorage.setItem('hoags_managers', JSON.stringify(stored));
//         }
//       } catch (e) { /* ignore */ }

//       resolve(result);
//     });
//   });
// }

// /**
//  * Resend verification code for a manager.
//  */
// export function resendManagerCode(email) {
//   return new Promise((resolve, reject) => {
//     const cognitoUser = new CognitoUser({
//       Username: email.toLowerCase(),
//       Pool: ADMIN_POOL,
//     });
//     cognitoUser.resendConfirmationCode((err, result) => {
//       if (err) return reject(err);
//       resolve(result);
//     });
//   });
// }

// /**
//  * Get locally stored managers list.
//  * (For the managers list panel — reads from localStorage)
//  */
// export function getStoredManagers() {
//   try {
//     return JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//   } catch {
//     return [];
//   }
// }


// // src/cognito.js
// // Dual Cognito pool configuration — Admin and User
// import {
//   CognitoUserPool,
//   CognitoUser,
//   CognitoUserAttribute,
//   AuthenticationDetails,
// } from 'amazon-cognito-identity-js';

// // ── Pool configs ─────────────────────────────────────────────────────────────
// const ADMIN_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_DZUDc4tDX',      // original admin pool
//   ClientId:   '75ql5hhopq20p1u0fau4rjgb3v',
// });

// const USER_POOL = new CognitoUserPool({
//   UserPoolId: 'ap-south-1_KDDaUsYp1',       // new user pool
//   ClientId:   '7rjgl5bi96pac7j6b994q25lb',
// });

// // Export whichever pool is active (used by App.js for getCurrentSession)
// export let userPool = USER_POOL;

// /**
//  * Sign in against the chosen role's Cognito pool.
//  * role: 'admin' | 'user'
//  */
// export function signIn(username, password, role = 'user') {
//   const pool = role === 'admin' ? ADMIN_POOL : USER_POOL;
//   // Keep userPool in sync so getCurrentSession / signOut work correctly
//   userPool = pool;

//   return new Promise((resolve, reject) => {
//     const authDetails = new AuthenticationDetails({
//       Username: username,
//       Password: password,
//     });
//     const cognitoUser = new CognitoUser({ Username: username, Pool: pool });
//     cognitoUser.authenticateUser(authDetails, {
//       onSuccess: (session) => resolve({ session, cognitoUser, role }),
//       onFailure: (err) => reject(err),
//       newPasswordRequired: (userAttributes) => {
//         reject({ code: 'NewPasswordRequired', userAttributes, cognitoUser });
//       },
//     });
//   });
// }

// /**
//  * Sign out — tries both pools so the active session is always cleared.
//  */
// export function signOut() {
//   [ADMIN_POOL, USER_POOL].forEach(pool => {
//     const user = pool.getCurrentUser();
//     if (user) user.signOut();
//   });
// }

// /**
//  * Get the current session from whichever pool last signed in.
//  * Tries USER_POOL first, falls back to ADMIN_POOL.
//  */
// export function getCurrentSession() {
//   return new Promise((resolve, reject) => {
//     const tryPool = (pool) =>
//       new Promise((res, rej) => {
//         const user = pool.getCurrentUser();
//         if (!user) return rej(new Error('No current user'));
//         user.getSession((err, session) => {
//           if (err || !session?.isValid()) return rej(err || new Error('Invalid session'));
//           userPool = pool; // keep in sync
//           res(session);
//         });
//       });

//     tryPool(USER_POOL)
//       .then(resolve)
//       .catch(() => tryPool(ADMIN_POOL).then(resolve).catch(reject));
//   });
// }

// // ══════════════════════════════════════════════════════════════════════════════
// // ROLE MANAGEMENT — Sign up managers directly from frontend
// // ══════════════════════════════════════════════════════════════════════════════

// /**
//  * Create a new manager account via Cognito signUp (frontend SDK).
//  * Uses ADMIN_POOL so managers log in with the "admin" role toggle.
//  *
//  * @param {string} email
//  * @param {string} password
//  * @param {string} fullName
//  * @param {string} role          — e.g. 'service_manager'
//  * @param {string[]} permissions — e.g. ['onboard_customers','recharge']
//  * @returns {Promise<{ user, userConfirmed, userSub }>}
//  */
// export function signUpManager(email, password, fullName, role = 'service_manager', permissions = []) {
//   return new Promise((resolve, reject) => {
//     const attributeList = [
//       new CognitoUserAttribute({ Name: 'email', Value: email.toLowerCase() }),
//       new CognitoUserAttribute({ Name: 'name',  Value: fullName || email.split('@')[0] }),
//     ];

//     // Permissions are stored in localStorage (not Cognito custom attributes)
//     // to avoid needing pool-level custom attribute configuration.

//     ADMIN_POOL.signUp(
//       email.toLowerCase(),  // username = email
//       password,
//       attributeList,
//       null,                 // validation data
//       (err, result) => {
//         if (err) {
//           console.error('[signUpManager] Error:', err);
//           return reject(err);
//         }
//         console.log('[signUpManager] Created:', result.user.getUsername(), 'confirmed:', result.userConfirmed);

//         // Also store permissions locally for quick lookup
//         // (backup in case custom attributes aren't configured)
//         try {
//           const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//           stored.push({
//             email: email.toLowerCase(),
//             fullName: fullName || '',
//             role,
//             permissions,
//             status: result.userConfirmed ? 'CONFIRMED' : 'UNCONFIRMED',
//             userSub: result.userSub,
//             createdAt: new Date().toISOString(),
//           });
//           localStorage.setItem('hoags_managers', JSON.stringify(stored));
//         } catch (e) { /* ignore */ }

//         resolve({
//           user: result.user,
//           userConfirmed: result.userConfirmed,
//           userSub: result.userSub,
//         });
//       }
//     );
//   });
// }

// /**
//  * Confirm a manager's email with verification code.
//  * Call this after signUpManager if the pool requires email verification.
//  *
//  * @param {string} email
//  * @param {string} code — 6-digit code from email
//  */
// export function confirmManager(email, code) {
//   return new Promise((resolve, reject) => {
//     const cognitoUser = new CognitoUser({
//       Username: email.toLowerCase(),
//       Pool: ADMIN_POOL,
//     });
//     cognitoUser.confirmRegistration(code, true, (err, result) => {
//       if (err) return reject(err);

//       // Update local status
//       try {
//         const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//         const idx = stored.findIndex(m => m.email === email.toLowerCase());
//         if (idx >= 0) {
//           stored[idx].status = 'CONFIRMED';
//           localStorage.setItem('hoags_managers', JSON.stringify(stored));
//         }
//       } catch (e) { /* ignore */ }

//       resolve(result);
//     });
//   });
// }

// /**
//  * Resend verification code for a manager.
//  */
// export function resendManagerCode(email) {
//   return new Promise((resolve, reject) => {
//     const cognitoUser = new CognitoUser({
//       Username: email.toLowerCase(),
//       Pool: ADMIN_POOL,
//     });
//     cognitoUser.resendConfirmationCode((err, result) => {
//       if (err) return reject(err);
//       resolve(result);
//     });
//   });
// }

// /**
//  * Get locally stored managers list.
//  * (For the managers list panel — reads from localStorage)
//  */
// export function getStoredManagers() {
//   try {
//     return JSON.parse(localStorage.getItem('hoags_managers') || '[]');
//   } catch {
//     return [];
//   }
// }



// src/cognito.js
// Dual Cognito pool configuration — Admin and User
import {
  CognitoUserPool,
  CognitoUser,
  CognitoUserAttribute,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';

// ── Pool configs ─────────────────────────────────────────────────────────────
const ADMIN_POOL = new CognitoUserPool({
  UserPoolId: 'ap-south-1_DZUDc4tDX',      // original admin pool
  ClientId:   '75ql5hhopq20p1u0fau4rjgb3v',
});

const USER_POOL = new CognitoUserPool({
  UserPoolId: 'ap-south-1_KDDaUsYp1',       // new user pool
  ClientId:   '7rjgl5bi96pac7j6b994q25lb',
});

const MANAGER_POOL = new CognitoUserPool({
  UserPoolId: 'ap-south-1_xdOfrQvBU',       // separate pool for managers
  ClientId:   '6mlej7bfm2lkesafoapd5pmi4o',
});

// Export whichever pool is active (used by App.js for getCurrentSession)
export let userPool = USER_POOL;

/**
 * Authenticate against a specific Cognito pool.
 */
function authenticateAgainstPool(pool, username, password, role) {
  return new Promise((resolve, reject) => {
    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    const cognitoUser = new CognitoUser({ Username: username, Pool: pool });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ session, cognitoUser, role }),
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => {
        reject({ code: 'NewPasswordRequired', userAttributes, cognitoUser });
      },
    });
  });
}

/**
 * Sign in against the chosen role's Cognito pool.
 * role: 'admin' | 'user'
 *
 * For 'admin', tries ADMIN_POOL first (regular admin accounts), and if that
 * fails with a not-found/not-authorized error, falls back to MANAGER_POOL
 * (accounts created via Role Management). This lets managers sign in from
 * the same "Sign In as Admin" form without needing a separate toggle.
 */
export function signIn(username, password, role = 'user') {
  if (role === 'admin') {
    // Try ADMIN_POOL first (kishore@hoags.in etc.), then MANAGER_POOL
    // (admin accounts created via Role Management land in MANAGER_POOL
    // because that's the only pool the IAM policy covers).
    userPool = ADMIN_POOL;
    return authenticateAgainstPool(ADMIN_POOL, username, password, 'admin')
      .catch((err) => {
        const code = err && err.code;
        if (code === 'UserNotFoundException' || code === 'NotAuthorizedException') {
          userPool = MANAGER_POOL;
          return authenticateAgainstPool(MANAGER_POOL, username, password, 'admin');
        }
        throw err;
      });
  }

  const pool = USER_POOL;
  userPool = pool;
  return authenticateAgainstPool(pool, username, password, role);
}

/**
 * Sign out — tries both pools so the active session is always cleared.
 */
export function signOut() {
  [ADMIN_POOL, USER_POOL, MANAGER_POOL].forEach(pool => {
    const user = pool.getCurrentUser();
    if (user) user.signOut();
  });
}

/**
 * Get the current session from whichever pool last signed in.
 * Tries USER_POOL first, falls back to ADMIN_POOL.
 */
export function getCurrentSession() {
  return new Promise((resolve, reject) => {
    const tryPool = (pool) =>
      new Promise((res, rej) => {
        const user = pool.getCurrentUser();
        if (!user) return rej(new Error('No current user'));
        user.getSession((err, session) => {
          if (err || !session?.isValid()) return rej(err || new Error('Invalid session'));
          userPool = pool; // keep in sync
          res(session);
        });
      });

    tryPool(USER_POOL)
      .then(resolve)
      .catch(() => tryPool(ADMIN_POOL))
      .then(resolve)
      .catch(() => tryPool(MANAGER_POOL).then(resolve).catch(reject));
  });
}

// ══════════════════════════════════════════════════════════════════════════════
// ROLE MANAGEMENT — Sign up managers directly from frontend
// ══════════════════════════════════════════════════════════════════════════════

/**
 * Create a new manager account via Cognito signUp (frontend SDK).
 * Uses MANAGER_POOL so managers have their own separate Cognito pool.
 *
 * @param {string} email
 * @param {string} password
 * @param {string} fullName
 * @param {string} role          — e.g. 'service_manager'
 * @param {string[]} permissions — e.g. ['onboard_customers','recharge']
 * @returns {Promise<{ user, userConfirmed, userSub }>}
 */
export function signUpManager(email, password, fullName, role = 'service_manager', permissions = []) {
  return new Promise((resolve, reject) => {
    const attributeList = [
      new CognitoUserAttribute({ Name: 'email', Value: email.toLowerCase() }),
      new CognitoUserAttribute({ Name: 'name',  Value: fullName || email.split('@')[0] }),
    ];

    // Permissions are stored in localStorage (not Cognito custom attributes)
    // to avoid needing pool-level custom attribute configuration.

    MANAGER_POOL.signUp(
      email.toLowerCase(),  // username = email
      password,
      attributeList,
      null,                 // validation data
      (err, result) => {
        if (err) {
          console.error('[signUpManager] Error:', err);
          return reject(err);
        }
        console.log('[signUpManager] Created:', result.user.getUsername(), 'confirmed:', result.userConfirmed);

        // Also store permissions locally for quick lookup
        // (backup in case custom attributes aren't configured)
        try {
          const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
          stored.push({
            email: email.toLowerCase(),
            fullName: fullName || '',
            role,
            permissions,
            status: result.userConfirmed ? 'CONFIRMED' : 'UNCONFIRMED',
            userSub: result.userSub,
            createdAt: new Date().toISOString(),
          });
          localStorage.setItem('hoags_managers', JSON.stringify(stored));
        } catch (e) { /* ignore */ }

        resolve({
          user: result.user,
          userConfirmed: result.userConfirmed,
          userSub: result.userSub,
        });
      }
    );
  });
}

/**
 * Confirm a manager's email with verification code.
 * Call this after signUpManager if the pool requires email verification.
 *
 * @param {string} email
 * @param {string} code — 6-digit code from email
 */
export function confirmManager(email, code) {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: email.toLowerCase(),
      Pool: MANAGER_POOL,
    });
    cognitoUser.confirmRegistration(code, true, (err, result) => {
      if (err) return reject(err);

      // Update local status
      try {
        const stored = JSON.parse(localStorage.getItem('hoags_managers') || '[]');
        const idx = stored.findIndex(m => m.email === email.toLowerCase());
        if (idx >= 0) {
          stored[idx].status = 'CONFIRMED';
          localStorage.setItem('hoags_managers', JSON.stringify(stored));
        }
      } catch (e) { /* ignore */ }

      resolve(result);
    });
  });
}

/**
 * Resend verification code for a manager.
 */
export function resendManagerCode(email) {
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: email.toLowerCase(),
      Pool: MANAGER_POOL,
    });
    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) return reject(err);
      resolve(result);
    });
  });
}

/**
 * Get locally stored managers list.
 * (For the managers list panel — reads from localStorage)
 */
export function getStoredManagers() {
  try {
    return JSON.parse(localStorage.getItem('hoags_managers') || '[]');
  } catch {
    return [];
  }
}

// ══════════════════════════════════════════════════════════════════════════════
// FORGOT PASSWORD — public Cognito APIs, no admin credentials needed.
// Works for both ADMIN_POOL and MANAGER_POOL accounts (tries admin first,
// falls back to manager — same pattern as signIn()).
// ══════════════════════════════════════════════════════════════════════════════

/**
 * Step 1: request a password-reset code by email.
 * Resolves with { pool: 'admin' | 'manager' } so the caller knows which
 * pool to use in confirmForgotPassword.
 */
export function requestPasswordReset(email) {
  const tryPool = (pool, poolName) => new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({ Username: email.trim().toLowerCase(), Pool: pool });
    cognitoUser.forgotPassword({
      onSuccess: () => resolve({ pool: poolName }),
      onFailure: (err) => reject(err),
      inputVerificationCode: () => resolve({ pool: poolName }),
    });
  });

  return tryPool(ADMIN_POOL, 'admin').catch((err) => {
    const code = err && err.code;
    if (code === 'UserNotFoundException' || code === 'NotAuthorizedException') {
      return tryPool(MANAGER_POOL, 'manager');
    }
    throw err;
  });
}

/**
 * Step 2: confirm the code + set a new password.
 * poolName must be whatever requestPasswordReset resolved with.
 */
export function confirmPasswordReset(email, code, newPassword, poolName) {
  return new Promise((resolve, reject) => {
    const pool = poolName === 'manager' ? MANAGER_POOL : ADMIN_POOL;
    const cognitoUser = new CognitoUser({ Username: email.trim().toLowerCase(), Pool: pool });
    cognitoUser.confirmPassword(code, newPassword, {
      onSuccess: () => resolve(),
      onFailure: (err) => reject(err),
    });
  });
}